export default class DtoMobileNotification {
    constructor(obj) {
        this.mobileId = obj.mobileId
        this.plateforme = obj.plateforme
        this.app = obj.app
        this.login = obj.login
        this.date = obj.date
    }
}